var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 78,
    viewBox: "0 0 104 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 104,
    height: 78,
    rx: 20,
    transform: "translate(0 0.232)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "en",
    transform: "translate(0 -0.231)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M104.4,0H0V78.3H104.4Z",
    transform: "translate(0.168 -0.107)",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M92.161,0l-39.8,29.524L12.723,0H0V10.113l39.148,29.2L0,68.346V78.3H13.049L52.2,49.1,91.183,78.3H104.4V68.509L65.41,39.474,104.4,10.44V0Z",
    transform: "translate(0.168 -0.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M35.233,45.836,0,71.772V78.3l44.2-32.46ZM65.247,49.1l-.979,5.709L95.587,78.3H104.4ZM0,0V.489L40.616,31.155l-.326-7.177L8.156,0ZM104.4,0,65.41,28.709H75.2L104.4,6.851Z",
    transform: "translate(0.168 -0.107)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M65.084,0V78.3h-26.1V0ZM104.4,26.1V52.2H0V26.1Z",
    transform: "translate(0.168 -0.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M104.4,31.482V47.141H0V31.482ZM59.864,0V78.3H44.2V0Z",
    transform: "translate(0.168 -0.107)",
    fill: "#c8102e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.b4a1d6def998021a6e95373d53913519.svg";
export { ForwardRef as ReactComponent };